// Реестр web-экранов: компоненты по ключам ScreensList + метаданные.

import { ScreenCardPinSetup } from '@mobile/screens/card-pin-setup'
import { ScreensList } from '@shared-core/navigation'
import { SCREENS_PATHS, type ScreenRouteKey } from '@shared-core/navigation/screens-paths'
import { ScreenEntryEmail } from '@shared-ui/screens/entry/email'
import {
  ScreenCardDetails,
  ScreenCardInfo,
  ScreenEntryOtp,
  ScreenEntryPhone,
  ScreenHome,
  ScreenPaymentLink,
  ScreenTopupAmount,
  ScreenTxDetails,
  ScreenWithdrawAmount,
  ScreenWithdrawBanks,
} from '@web/screens'
import type { ComponentType } from 'react'

import { APP_ROUTE_KEYS, isPublicScreen } from './app-routes'

const COMPONENTS: Record<ScreenRouteKey, ComponentType> = {
  [ScreensList.ENTRY_EMAIL]: ScreenEntryEmail,
  [ScreensList.ENTRY_LOADING]: ScreenEntryPhone,
  [ScreensList.ENTRY_PHONE]: ScreenEntryPhone,
  [ScreensList.ENTRY_OTP]: ScreenEntryOtp,
  [ScreensList.HOME_START]: ScreenHome,
  [ScreensList.TOPUP_AMOUNT]: ScreenTopupAmount,
  [ScreensList.PAYMENT_LINK]: ScreenPaymentLink,
  [ScreensList.TX_DETAILS]: ScreenTxDetails,
  [ScreensList.CARD_INFO]: ScreenCardInfo,
  [ScreensList.CARD_DETAILS]: ScreenCardDetails,
  [ScreensList.CARD_PIN_SETUP]: ScreenCardPinSetup,
  [ScreensList.WITHDRAW_BANKS]: ScreenWithdrawBanks,
  [ScreensList.WITHDRAW_AMOUNT]: ScreenWithdrawAmount,
}

export type TabRouteKey = ScreenRouteKey

export function componentFor(key: ScreenRouteKey): ComponentType {
  return COMPONENTS[key]
}

export const homePath = `/${SCREENS_PATHS.HOME_START}`
export const loginPath = `/${SCREENS_PATHS.ENTRY_PHONE}`
export const tabRouteKeys: ScreenRouteKey[] = [ScreensList.HOME_START]

export const publicRouteKeys: ScreenRouteKey[] = APP_ROUTE_KEYS.filter(isPublicScreen)

export function toPath(key: ScreenRouteKey): string {
  return `/${SCREENS_PATHS[key]}`
}

export function isTabRootPath(pathname: string): boolean {
  return tabRouteKeys.some((key) => pathname === toPath(key))
}
